import moment from "moment";

const Title = (cell) => {
    return cell.value ? cell.value : '';
};
const Date = (cell) => {
  return cell.value ? moment (cell.value).format("yyyy-MM-DD") : ""
}; 
const CeremonyNameEn = (cell) => {
  return cell.value ? cell.value : ''
} 
export { Title, Date, CeremonyNameEn }